import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

// Full-width welcome video: autoplays (muted) when scrolled into view, pauses when scrolled away.
export const WelcomeVideo = () => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.4) v.play().catch(() => {});
        else v.pause();
      },
      { threshold: [0, 0.4, 1] }
    );
    io.observe(v);
    return () => io.disconnect();
  }, []);

  const toggleMute = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play().catch(() => {});
  };

  return (
    <div className="relative mt-10 w-full rounded-lg overflow-hidden border border-ei-white/10 shadow-2xl bg-black" data-testid="welcome-video-wrap">
      <video
        ref={ref}
        data-testid="home-welcome-video"
        className="w-full h-auto block aspect-video object-cover"
        poster="/media/welcome-poster.jpg"
        muted
        loop
        playsInline
        preload="metadata"
        controls
      >
        <source src="/media/ei-battery-welcome.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <button
        type="button"
        onClick={toggleMute}
        aria-label={muted ? "Unmute video" : "Mute video"}
        data-testid="welcome-video-mute"
        className="absolute top-4 right-4 z-10 inline-flex items-center gap-2 rounded-full bg-ei-navy/80 backdrop-blur px-4 py-2 text-xs font-bold text-ei-white hover:bg-ei-navy transition-colors"
      >
        {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />} {muted ? "Tap for sound" : "Sound on"}
      </button>
    </div>
  );
};
